import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import {OfferInfo} from "~/app/core/model/offer-info";
import {off} from "@angular/fire/database";
import {OfferFilter} from "~/app/core/model/offer-filter";
import {HomePage} from "~/app/pages/home/home.page";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {CoreService} from "~/app/core/core.service";

@Component({
    selector: "search",
    templateUrl: "./search.component.html",
    styleUrls: ["./search.component.scss"]
})
export class SearchComponent implements OnInit {
  @Input() homePage: HomePage;
  public offers: OfferInfo[] = [];
  public allOffers: OfferInfo[];
  public filter: OfferFilter = {};
  latitude: number = null;
  longitude: number = null;
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly core: CoreService
  ) {
  }

  ngOnInit(): void {
    this.findNearestLocation();
    this.allOffers = this.getAllOffers();
  }


  public wordSearch(e) {
    this.offers = [];
    const str = e.target.value;
    const searchVal = str.toLowerCase().trim();
    this.allOffers.forEach((offer) => {
      const name = offer.name.toLowerCase();
      const company = offer.companyName.toLowerCase();
      if (name.includes(searchVal)) {
        this.offers.push(offer);
      } else if (company.includes(searchVal)) {
        this.offers.push(offer);
      }
    });
    this.offers = this.offers.sort((a, b) => {
      let shortA = 999;
      a.addresses.forEach(address => {
        const something = this.calculateDistance(address);
          if (something < shortA) {
            shortA = something;
          }
        });

      let shortB = 999;
      b.addresses.forEach(address => {
        const something = this.calculateDistance(address);
        if (something < shortB) {
          shortB = something;
        }
      });
      console.log(shortA);
      console.log(shortB);
      return shortA - shortB;
    });
    console.log(this.offers);
  }

  private getAllOffers() {
    let offers: Array<OfferInfo> = this.api.offers_loadOffers(true, this.filter, 'all');

    // If we didn't get any results, query the api directly and wait for it to complete
    // Note: I think this means we're hitting the api twice, as offers_loadOffers presumably is already running it,
    // so this is not optimal. We need a bit of refactoring.
    if (!offers.length) {
      this.api.offers_performSearch().then(result => {
        offers = result;
        if (offers.length) {
          this.getAllOffers();
        }
      });
    }
    return offers;
  }

  calculateDistance(address: AddressInfo): number {
    const distance = this.milesAwayPrecise(address);
    if (distance) {
      return distance > 1 ? Math.round(distance) : Math.round(distance * 10) / 10;
    }
    return null;
  }

  milesAwayPrecise(address: AddressInfo): number {
    if (this.hasMilesAway(address)) {
      const distance = LocationInfo.milesAway(
        { longitude: address.longitude, latitude: address.latitude },
        { longitude: this.longitude, latitude: this.latitude }
      );
      console.log(address.city + " distance: " + distance);
      return distance;
    }
    return null;
  }

  hasMilesAway(address: AddressInfo): boolean {
    return !!address.latitude && !!address.longitude && !!this.longitude && !!this.latitude;
  }

  findNearestLocation() {
    this.core.api.location_getLocationInfo().then(locationInfo => {
      this.longitude = locationInfo.longitude;
      this.latitude = locationInfo.latitude;
    }, (error) => {
      console.log("unable to get location");
    });
  }
}
